import { useState } from "react";
import type { CreateMailOrderResponse } from "@gull/shared";
import { enduserApi, ApiError } from "../../../lib/api";
import type { MailOrderPayload } from "../payload";

export function useSubmitMailOrder() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (payload: MailOrderPayload): Promise<CreateMailOrderResponse | null> => {
    setSubmitting(true);
    setError(null);
    try {
      return await enduserApi.authedPost<CreateMailOrderResponse>("/mail-orders", payload);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Ukjent feil");
      return null;
    } finally {
      setSubmitting(false);
    }
  };

  return { submit, submitting, error };
}
